// Module
var code = "<div id=\"gridContainer\"></div> ";
// Exports
export default code;